<template>
  <b-row
    v-if="$route.meta.breadcrumb || $route.meta.pageTitle"
    class="content-header"
  >

    <!-- Content Left -->
    <b-col
      class="content-header-left mb-2"
      cols="12"
    >
      <b-row class="breadcrumbs-top">
        <b-col md="6" sm="5" xs="12" class="breadcrumb-first-item">
          <div class="breadcrumb-wrapper">
            <b-breadcrumb class="breadcrumb-slash">
              <b-breadcrumb-item :active="true">
                <IconSettings v-if="breadcrumb[0].icon == 'settings'"/>
                <IconApontamentos v-else-if="breadcrumb[0].icon == 'apontamentos'"/>
                <IconHome v-else/>
              </b-breadcrumb-item>
              <b-breadcrumb-item
                v-for="item in breadcrumb"
                :key="item.text"
                :active="item.to ? false : true"
                :to="item.to"
                :class="[
                item.to && 'navigable',
                item.active && 'activePage'
                ]"
                
              >
                {{ $t(item.text) }}
              </b-breadcrumb-item>
            </b-breadcrumb>
          </div>
        </b-col>

        <b-col md="6" sm="7" xs="12" class="breadcrumb-second-item">
          <slot name="col-right" />
        </b-col>
      </b-row>
    </b-col>
  </b-row>
</template>

<script>
import {
  BBreadcrumb, BBreadcrumbItem, BRow, BCol, BDropdown, BDropdownItem, BButton,
} from 'bootstrap-vue'
import Ripple from 'vue-ripple-directive'
import IconHome from '../../assets/images/pages/home-icon.svg'
import IconSettings from '../../assets/images/pages/settings-page-icon.svg'
import IconApontamentos from '@/assets/images/pages/apontamentos-icon-vertical.svg'


export default {
  directives: {
    Ripple,
  },
  components: {
    BBreadcrumb,
    BBreadcrumbItem,
    BRow,
    BCol,
    BDropdown,
    BDropdownItem,
    BButton,
    IconHome,
    IconSettings,
    IconApontamentos
  },
  data() {
    return {
      breadcrumb: {},
    }
  },
  mounted() {
    this.breadcrumb = this.$route.meta.breadcrumb
  },
  methods: {
   
  },
  watch:{
     '$route.meta.breadcrumb'(){
       this.breadcrumb = this.$route.meta.breadcrumb
     }
  }
}
</script>
<style lang="scss">

@media (max-width: 480px) {
  .breadcrumb-wrapper{
    margin-bottom: 24px;
    .breadcrumb{
      padding: 0
    }
  }
}

.breadcrumb-wrapper{
    .breadcrumb-item{
        display: flex;
        align-items: center;
        &::before{
            font-family: 'Roboto';
            font-style: normal;
            font-weight: 600;
            font-size: 14px;
            line-height: 20px;
        }
        span{
            display: flex;
            font-family: 'Roboto';
            font-style: normal;
            font-weight: 400;
            font-size: 14px;
            line-height: 20px;
            color: #998F8A;

        }
        &.activePage{
            span{
                color: #974900;
            }
        }
        &.navigable{
            a{
                color: #998F8A;
            }
        }
    }
}
</style>
